import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import { suppliersAPI } from '../../lib/api';

const Suppliers = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSuppliers = async () => {
    setLoading(true);
    try {
      const response = await suppliersAPI.getAll();
      setSuppliers(response.data);
    } catch (error) {
      console.error('Error fetching suppliers:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSuppliers();
  }, []);

  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Phone' },
    { key: 'contact_person', label: 'Contact Person' },
    { key: 'status', label: 'Status', type: 'status' },
  ];

  const formFields = [
    { name: 'name', label: 'Supplier Name', required: true, placeholder: 'Enter supplier name' },
    { name: 'email', label: 'Email', type: 'email', placeholder: 'supplier@example.com' },
    { name: 'phone', label: 'Phone', placeholder: '+1-555-0000' },
    { name: 'contact_person', label: 'Contact Person', placeholder: 'Primary contact' },
    { name: 'address', label: 'Address', type: 'textarea', placeholder: 'Full address' },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      defaultValue: 'active',
      options: [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
      ],
    },
  ];

  const handleAdd = async (data) => {
    await suppliersAPI.create(data);
    fetchSuppliers();
  };

  const handleEdit = async (id, data) => {
    await suppliersAPI.update(id, data);
    fetchSuppliers();
  };

  const handleDelete = async (id) => {
    await suppliersAPI.delete(id);
    fetchSuppliers();
  };

  return (
    <DataTable
      title="Suppliers"
      description="Manage your supplier relationships"
      data={suppliers}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      loading={loading}
    />
  );
};

export default Suppliers;
